"use strict";
/**
 * global identifier for Sportradar Resources
 *
 * input:
 *  - domainName        - reporting     - string
 *  - resourceType      - weekly-report - string
 *  - resourceId        - 12            - string | number
 *  - ownerId           - uuid          - string
 *  - holdingId         - 12            - string | number
 *  - businessEntityId  - 12            - string | number
 *
 * output format:
 *  - srn:holding:business-entity:domain:resource-type:resource-id:owner
 *
 * DANGER!
 *  - If you keep a value in construction empty, it will be replaced with the globalIdentifier
 *    this can resolve in unwanted behavior, because it will be treated as a wildcard.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportradarResourceName = void 0;
class SportradarResourceName {
    static wildcardSymbol = '*';
    static prefix = 'srn';
    static delimiter = ':';
    static globalIdentifier = '';
    static blockCount = 7;
    holdingId;
    businessEntityId;
    domainName;
    resourceType;
    resourceId;
    ownerId;
    constructor(domainName, resourceType, resourceId, ownerId, holdingId, businessEntityId) {
        this.domainName = domainName;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.ownerId = ownerId;
        this.holdingId = holdingId || SportradarResourceName.globalIdentifier;
        this.businessEntityId = businessEntityId || SportradarResourceName.globalIdentifier;
    }
    toString() {
        return [
            SportradarResourceName.prefix,
            String(this.holdingId),
            String(this.businessEntityId),
            this.domainName,
            this.resourceType,
            String(this.resourceId),
            this.ownerId,
        ].join(SportradarResourceName.delimiter);
    }
    static fromString(srn) {
        const splitSrn = srn.split(SportradarResourceName.delimiter);
        if (splitSrn.length > SportradarResourceName.blockCount) {
            throw Error('Invalid SRN-Pattern');
        }
        const [, resourceHolding, resourceAdvertiser, resourceDomain, resourceType, resourceId, resourceOwnerId] = splitSrn;
        return new SportradarResourceName(resourceDomain, resourceType, resourceId, resourceOwnerId, resourceHolding, resourceAdvertiser);
    }
}
exports.SportradarResourceName = SportradarResourceName;
//# sourceMappingURL=SportradarResourceName.js.map